// @ts-nocheck
import { CarrierInfoModel } from "@store/Framework/Store/Store/Pages/CheckoutShipping/CheckoutShippingState";
import { createHandlerChainRunner, Handler } from "@toolkit/Modules/client-framework/HandlerCreator";

type HandlerType = Handler<{ carrierInfo: CarrierInfoModel }>;

export const DispatchSetCarrierInfo: HandlerType = props => {
    props.dispatch({
        type: "Store/Pages/CheckoutShipping/SetCarrierInfo",
        carrierInfo: props.parameter.carrierInfo,
    });
};

export const chain = [DispatchSetCarrierInfo];

const setCarrierInfo = createHandlerChainRunner(chain, "SetCarrierInfo");
export default setCarrierInfo;
